import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import styled, { css } from "styled-components";
import { token } from "./token.js";
import { Tab } from "./Tab.js";
import { TabsContext } from "./context8.js";
import { declareTokens, internalTokens } from "./themes.js";
function Tabs({
  variant = "contained",
  shape = "rounded",
  children,
  ...props
}) {
  const contextValue = useMemo(() => {
    return {
      variant,
      shape
    };
  }, [variant, shape]);
  return /* @__PURE__ */ jsx(TabsStyled, {
    $variant: variant,
    $shape: shape,
    ...props,
    children: /* @__PURE__ */ jsx(TabsContext.Provider, {
      value: contextValue,
      children
    })
  });
}
Tabs.Tab = Tab;
const TabsStyled = styled.div.withConfig({
  displayName: "TabsStyled",
  componentId: "sc-10cm7tx-0"
})(["", " display:flex;gap:", ";align-items:center;border-radius:", ";", ";"], declareTokens, token.spacing1, (props) => props.$shape === "pill" ? token.radiusPill : `calc(${token.radiusBase} + 2px) `, (props) => props.$variant === "contained" && css(["padding:", ";background-color:", ";"], token.spacing1, internalTokens["tabs-background-color"]));
export {
  Tabs
};
//# sourceMappingURL=Tabs.js.map
